// src/Redux/Store.jsx
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import vendorsReducer from './Reducer/vendorsReducer';
import ProductReducer from './Reducer/ProductReducer';
import employeesReducer from './Reducer/EmployeeSlice';
import salesReducer from './Reducer/SaleSlice';
import comboPackReducer from './Reducer/ComboPackReducer';

const persistConfig = {
  key: 'root',
  version: 1,
  storage
};

const reducer = combineReducers({
  vendor: vendorsReducer,
  product : ProductReducer,
  employee: employeesReducer,
  sale:salesReducer,
  comboPack: comboPackReducer
});

const persistedReducer = persistReducer(persistConfig, reducer);

// Create store
const store = configureStore({
  reducer: persistedReducer
});

// Create persistor
export const persistor = persistStore(store);

export default store;
